/* 記事一覧の画像&テキスト表示とテキスト表示の切り替えをするための関数
 *
 * @params {string} triggerThumbClassName クリックで画像&テキスト表示のイベントトリガーになる要素のクラス名
 * @params {string} triggerTextClassName クリックでテキストのみ表示のイベントトリガーになる要素のクラス名
 * @params {string} targetListClassName クラス名"only-text"をadd/removeする対象の要素のクラス名
*/

const changeArticleDisplay = (triggerThumbClassName, triggerTextClassName, targetListClassName) => {
  const $elements = {
    triggerThumb: document.getElementsByClassName(triggerThumbClassName)[0],
    triggerText: document.getElementsByClassName(triggerTextClassName)[0],
    targetList: document.getElementsByClassName(targetListClassName)[0]
  };

  const storageKey = 'articleDisplayType';

  const displayType = {
    thumbnail: 'thumb',
    onlyText: 'text'
  };

  function removeAllClass () {
    $elements.triggerThumb.classList.remove('active');
    $elements.triggerText.classList.remove('active');
  }

  function toggleTargetClassActive (flg) {
    if (flg === displayType.thumbnail) {
      $elements.targetList.classList.remove('only-text');
    } else if (flg === displayType.onlyText) {
      $elements.targetList.classList.add('only-text');
    }
  }

  function addTriggerClassActive (flg) {
    if (flg === displayType.thumbnail) {
      $elements.triggerThumb.classList.add('active');
    } else if (flg === displayType.onlyText) {
      $elements.triggerText.classList.add('active');
    }
  }

  function addDisplayTypeToLocalStorage (type) {
    localStorage.setItem(storageKey, type);
  }

  function classToggleEventHandler (type) {
    removeAllClass();
    addTriggerClassActive(type);
    toggleTargetClassActive(type);
  }

  function addEvent () {
    $elements.triggerThumb.addEventListener('click', () => {
      addDisplayTypeToLocalStorage(displayType.thumbnail);
      classToggleEventHandler(displayType.thumbnail);
    });
    $elements.triggerText.addEventListener('click', () => {
      addDisplayTypeToLocalStorage(displayType.onlyText);
      classToggleEventHandler(displayType.onlyText);
    });
  }

  function getStorageValue () {
    const typeInStorage = localStorage.getItem(storageKey);
    return typeInStorage !== null ? typeInStorage : displayType.thumbnail;
  }

  function isElementsExist () {
    return $elements.triggerThumb && $elements.triggerText && $elements.targetList;
  }

  function init () {
    if (isElementsExist()) {
      const displayType = getStorageValue();
      classToggleEventHandler(displayType);
      addEvent();
    }
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  changeArticleDisplay('js-change-article-display-trigger-thumbnail', 'js-change-article-display-trigger-text', 'js-change-article-display-target');
});
